import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { COPY } from '../../constants';

const PageFallback = () => {
  const navigate = useNavigate();

  return (
    <Grid
      size={12}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography variant="h5" sx={{ padding: 3 }}>
        {COPY.fallback.header}
      </Typography>
      <Typography variant="body1">{COPY.fallback.pageExplanation}</Typography>
      <Button
        onClick={() => navigate(-1)}
        color="primary"
        variant="contained"
        disableElevation
        sx={{ borderRadius: 3, margin: 3, fontSize: '10pt' }}
      >
        {COPY.fallback.pageButton}
      </Button>
    </Grid>
  );
};

export default PageFallback;
